import { Route, Routes } from "react-router";
import login from "../pages/login";
import dashboard from "../pages/dashboard";
import users from "../pages/users";
import projects from "../pages/projects/projects";
import clients from "../pages/clients";
import AssignUser from '../pages/assign-user'
import DailyTimesheet from "../pages/timesheet/daily-timesheet"; 

import MonthlyTimesheet from "../pages/timesheet/monthly-timesheet"; 
import WeeklyTimesheet from "../pages/timesheet/weekly-timesheet"; 
import ImportTimeSheet from "../pages/timesheet/import-timesheet"; 
// import SessionTimeout from "./components/SessionTimeout";


export const pageRoutes = {
    login: "/",
    dashboard:"/dashboard",
    users:"/users",
    projects:"/projects",
    clients:"/clients",
    assignuser:"/assign-users",
    projectuser:"/project-users",
    teamusers:"/team-users",
    daily:"/timesheet/daily",
    monthly:"/timesheet/monthly",
    weekly:"/timesheet/weekly",
    reports:"/reports",
    projectdetails:"/project-details",
    ImportTimeSheet:"/timesheet/import-timesheet",

}


export const AllRoutes = [
];